import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, Icon } from 'semantic-ui-react';
import CreditStats from '../CreditStats';

const ProfileStats = () => (
  <Grid doubling columns={6} className="profile-stats">
    <Grid.Row>
      <Grid.Column width={13}>
        <CreditStats />
      </Grid.Column>
      <Grid.Column verticalAlign="middle">
        <div className="credit-link">
          <Link to="/settings/credits">
            View credits history
            <Icon name="arrow right" />
          </Link>
        </div>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default ProfileStats;
